import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Redirect,Switch } from 'react-router-dom';
import LayoutComponent from './globals/Layout/Layout';
import Login from './components/Login/Login';
import { isAuthenticated } from './services/auth';
import { getUserByTokenAPI } from './services/restcall';
import { associateRouteDecision, readRememberedRole, rememberRole } from './auth/portfolioAssociate';
import { PUBLIC_PASSWORD_RESET_PATH } from './auth/publicRoutes';
import Users from './components/Admin/Users';
import Organization from './components/Admin/Organization';
import ChangePassword from './components/Admin/ChangePassword';
import Welcome from './components/Admin/Welcome';
import AdminSideBar from './globals/Layout/Admin/Sidebar';
import PublicChangePassword from './components/PublicChangePassword/PublicChangePassword';
import GeiInventory from './components/Admin/GeiInventory';
import Establishment from './components/Admin/Establishment';
import Category  from './components/Admin/Category';
import Emissions from './components/Admin/Emissions';
import Activities from './components/Admin/Activity';
import Sources from './components/Admin/Source';
import Pcg from './components/Admin/Pcg';
import Factors from './components/Admin/Factors';
import Tag from './components/Admin/Tag';
import Results from './components/Admin/Result/Results';
import ResultsMensual from './components/Admin/Result/ResultsMensual';
import ResultsUnified from './components/Admin/Result/ResultsUnified';
import ResultsMensualUnified from './components/Admin/Result/ResultsMensualUnified';
import GeiEstablishment from './components/Admin/GeiEstablishment';
import GeiEvent from './components/Admin/GeiEvent';
import TypeEvent from './components/Admin/TypeEvent';
import TypeOrganization from './components/Admin/TypeOrganization';
import PortafolioOrganization from './components/Admin/Tables/GeiPortafolio/PortafolioOrganization';
import TPortafolioGei from './components/Admin/Tables/GeiPortafolio/TPortafolioGei';
import PowerBI from './components/Admin/Tables/PowerBI/PowerBI';
import AuditHistory from './components/Admin/Audit/AuditHistory';
const ConfigRouter: React.FC = () => {
  return (

    <Router>       
      <Switch>
      <PublicRouteWrapper path='/' exact component={Login} layout={LayoutComponent} />  
      <PublicRouteWrapper path={PUBLIC_PASSWORD_RESET_PATH} exact component={PublicChangePassword} layout={LayoutComponent} />     
      <PrivateRouteWrapper path='/users' component={Users}  />
      <PrivateRouteWrapper path='/welcome' component={Welcome}  />
      <PrivateRouteWrapper path='/audit' component={AuditHistory}  />
      <PrivateRouteWrapper path='/change-password' component={ChangePassword}  />
      <PrivateRouteWrapper path='/organization' component={Organization}  /> 
      <PrivateRouteWrapper path='/event' component={GeiEvent}  /> 
      <PrivateRouteWrapper path='/typeevent' component={TypeEvent}  /> 
      <PrivateRouteWrapper path='/gei-inventory' component={GeiInventory}  /> 
      <PrivateRouteWrapper path='/establishment/gei/:idGei' component={GeiEstablishment}  />
      <PrivateRouteWrapper path='/establishment/:idOrganization' component={Establishment} />
      <PrivateRouteWrapper path= '/category' component={Category}/>
      <PrivateRouteWrapper path= '/emissions' component={Emissions}/>
      <PrivateRouteWrapper path= '/activity/:idEstablishmentGei/:idGei' component={Activities}/> 
      <PrivateRouteWrapper path= '/pcg' component={Pcg}/>
      <PrivateRouteWrapper path= '/sources' component={Sources}/>
      <PrivateRouteWrapper path= '/tags' component={Tag}/>
      <PrivateRouteWrapper path= '/factors' component={Factors}/>
      <PrivateRouteWrapper path= '/results/annual' component={Results}/>
      <PrivateRouteWrapper path= '/results/unified/annual' component={ResultsUnified}/>
      <PrivateRouteWrapper path= '/results/mensual' component={ResultsMensual}/>
      <PrivateRouteWrapper path= '/results/unified/mensual' component={ResultsMensualUnified}/>
      <PrivateRouteWrapper path='/type-organization' component={TypeOrganization}  /> 
      <PrivateRouteWrapper path='/portf-organization' component={PortafolioOrganization}  /> 
      <PrivateRouteWrapper path='/portafolio-gei' component={TPortafolioGei}  /> 
      <PrivateRouteWrapper path='/powerbi/:idOrganization/:typeEvent' component={PowerBI}  /> 
      
      
      </Switch> 
    </Router>

  );
};

const PublicRouteWrapper = (props: any) => {
  const { component: Component, layout: LayoutComponent, ...rest } = props;
  return (
    <Route {...rest} render={(props: any) =>
      <LayoutComponent {...props}>
        <Component {...props} />
      </LayoutComponent>
    } />
  );
}
function PrivateRouteWrapper(props: any) {
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={routeProps =>
        isAuthenticated() ? (
          <AssociateRouteGate pathname={routeProps.location?.pathname}>
            <AdminSideBar {...routeProps}>
              <Component {...routeProps} />
            </AdminSideBar>
          </AssociateRouteGate>
        ) : (
          <Redirect
            to={{
              pathname: "/",
            }}
          />
        )
      }
    />
  );
}

function AssociateRouteGate(props: { pathname: string; children: React.ReactNode }) {
  const [decision, setDecision] = useState<'allow' | 'deny' | 'unknown'>(() =>
    associateRouteDecision(readRememberedRole(), props.pathname)
  );

  useEffect(() => {
    const remembered = associateRouteDecision(readRememberedRole(), props.pathname);
    if (remembered !== 'unknown') {
      setDecision(remembered);
      return;
    }
    let cancelled = false;
    getUserByTokenAPI()
      .then((response) => {
        if (cancelled) {
          return;
        }
        const role = response?.StatusCode === 200 ? response.Response?.rol : null;
        if (role) {
          rememberRole(role);
          setDecision(associateRouteDecision(role, props.pathname));
          return;
        }
        setDecision('allow');
      })
      .catch(() => {
        if (!cancelled) {
          setDecision('allow');
        }
      });
    return () => {
      cancelled = true;
    };
  }, [props.pathname]);

  if (decision === 'unknown') {
    return null;
  }
  if (decision === 'deny') {
    return <Redirect to="/portafolio-gei" />;
  }
  return <>{props.children}</>;
}

// function PrivateWorkOrderRouteWrapper(props: any) {
//   const { component: Component, ...rest } = props;
//   return (
//     <Route
//       {...rest}
//       render={props =>
//         isAuthenticated() ? (
//           <WorkOrderSidebar {...props}>
//             <Component {...props} />
//           </WorkOrderSidebar>
//         ) : (
//           <Redirect
//             to={{
//               pathname: "/",
//             }}
//           />
//         )
//       }
//     />
//   );



export default ConfigRouter;
